/** Kleine Helfer fürs Nachrichtenfenster — ohne React, ohne Server. */
import type { FadenKurz, NachrichtArt } from "../hooks/useNachrichten";

export const ART_LABEL: Record<NachrichtArt, string> = { kunde: "Kunde", leed: "Leed", lieferant: "Lieferant" };

/** „14:05" heute, „gestern", „Mo" diese Woche, sonst „12.09.". */
export function zeitKurz(iso: string, jetzt = new Date()): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const tag = (x: Date) => new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime();
  const abstand = Math.round((tag(jetzt) - tag(d)) / 86_400_000);
  if (abstand === 0) return d.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" });
  if (abstand === 1) return "gestern";
  if (abstand > 1 && abstand < 7) return d.toLocaleDateString("de-DE", { weekday: "short" }).replace(".", "");
  return d.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit" }) + ".";
}

/** Überschrift zwischen den Blasen: „Heute", „Gestern", „Montag, 22. September". */
export function tagTitel(iso: string, jetzt = new Date()): string {
  const d = new Date(iso);
  const tag = (x: Date) => new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime();
  const abstand = Math.round((tag(jetzt) - tag(d)) / 86_400_000);
  if (abstand === 0) return "Heute";
  if (abstand === 1) return "Gestern";
  return d.toLocaleDateString("de-DE", {
    weekday: "long", day: "numeric", month: "long", ...(d.getFullYear() !== jetzt.getFullYear() ? { year: "numeric" } : {}),
  });
}

export function initialen(name: string): string {
  const teile = name.replace(/[^\p{L}\s-]/gu, " ").split(/\s+/).filter((t) => t && !/^(familie|herr|frau|gmbh|kg|co)$/i.test(t));
  if (teile.length === 0) return "?";
  if (teile.length === 1) return teile[0].slice(0, 2).toUpperCase();
  return (teile[0][0] + teile[teile.length - 1][0]).toUpperCase();
}

/** „Re: " nur einmal. */
export function reBetreff(betreff: string): string {
  const b = betreff.trim();
  if (!b) return "Ihre Nachricht";
  return /^(re|aw|antw)\s*:/i.test(b) ? b : `Re: ${b}`;
}

/** Wer von uns geschrieben hat: „Du" oder der Vorname des Partners, aus `namen` (Postfach → Name). */
export function wirName(von: string, namen: Record<string, string>): string {
  const adr = (von.match(/[^<\s]+@[^>\s]+/)?.[0] || von).toLowerCase();
  if (namen[adr]) return namen[adr];
  const lokal = adr.split("@")[0] || "";
  return lokal ? lokal[0].toUpperCase() + lokal.slice(1) : "Wir";
}

/** Zeile unter dem Namen: Projekt, sonst was fehlt. */
export function zuordnungText(f: Pick<FadenKurz, "art" | "projekt_titel" | "vorschlag">): string {
  if (f.art === "leed") return "neue Anfrage";
  if (!f.projekt_titel) return "ohne Projekt";
  return f.vorschlag ? `${f.projekt_titel}?` : f.projekt_titel;
}
